import Cart from '../services/cart';
const getBasicCartInfo = () => {
    return Cart.getSummary().then((summary) => {
        return {
            value: summary.products_summary.products_value,
            currency: typeof window.__STATE__ === 'undefined' ? '' : window.__STATE__.localization.currency_iso,
            items: summary.products.map((product) => {
                return {
                    item_id: product.code,
                    item_name: product.name_without_attribute,
                    item_variant: product.attribute_name ?? '',
                    item_brand: 'YvesRocher',
                    item_category: product.category ?? '',
                    price: product.price,
                    discount: product.catalogue_price - product.price,
                    currency: typeof window.__STATE__ === 'undefined' ? '' : window.__STATE__.localization.currency_iso,
                    quantity: product.quantity,
                };
            }),
            shipping_tier: summary.delivery?.name,
        };
    });
};
const sendEvent = (name, params) => {
    if (typeof window.gtag !== 'undefined') {
        window.gtag('event', name, params);
    }
};
const shippingInfoSend = (e) => {
    const { name } = e.detail;
    getBasicCartInfo()
        .then((info) => {
        const eventParams = { ...info, shipping_tier: name };
        sendEvent('add_shipping_info', eventParams);
        window.dispatchEvent(new CustomEvent('shipping-info-sent'));
    })
        .catch((err) => {
        console.error('Error while generating add_shipping_info event', err);
    });
};
const init = () => {
    if (typeof window.gtag === 'undefined') {
        return;
    }
    // Zmiana metody płatności
    window.addEventListener('payment-method-change', (e) => {
        const { name } = e.detail;
        getBasicCartInfo()
            .then((info) => {
            const eventParams = info;
            eventParams.payment_type = name;
            sendEvent('add_payment_info', eventParams);
            window.dispatchEvent(new CustomEvent('payment-info-sent'));
        })
            .catch((err) => {
            console.error('Error while generating add_payment_info event', err);
        });
    });
    // Zmiana metody dostawy
    window.addEventListener('delivery-method-change', (e) => {
        shippingInfoSend(e);
    });
    // Wyświetlenie koszyka
    if (window.location.pathname === '/cart') {
        getBasicCartInfo()
            .then((info) => {
            sendEvent('view_cart', info);
        })
            .catch((err) => {
            console.error('Error while generating view_cart event', err);
        });
    }
    // Potwierdzenie zamówienia (kliknięcie w przycisk "I confirm order")
    window.addEventListener('begin-checkout', () => {
        getBasicCartInfo()
            .then((info) => {
            sendEvent('begin_checkout', info);
            window.dispatchEvent(new CustomEvent('begin-checkout-sent'));
        })
            .catch((err) => {
            console.error('Error while generating begin_checkout event', err);
        });
    });
    // Otwarcie formularza dodawania nowego adresu
    window.addEventListener('cart-add-address.opened', () => {
        sendEvent('cart.change_address_data', {});
    });
    // Dodanie produktu do koszyka
    Cart.addListener((event) => {
        if (event.name !== 'cartUpdate') {
            return;
        }
        getBasicCartInfo()
            .then((info) => {
            // Odnalezienie wiersza z dodanym produktem
            info.items = info.items.filter((item) => {
                return item.item_id === event.details.sku;
            });
            info.value = info.items
                .map((item) => item.price * item.quantity)
                .reduce((prev, next) => {
                return prev + next;
            });
            info.value = Math.round(info.value * 100) / 100;
            sendEvent('add_to_cart', info);
        })
            .catch((err) => {
            console.error('Error while generating add_to_cart event', err);
        });
    });
    // Usunięcie produktu z koszyka
    window.addEventListener('cart-remove-row', (e) => {
        const { sku } = e.detail;
        getBasicCartInfo()
            .then((info) => {
            // Odnalezienie wiersza z dodanym produktem
            info.items = info.items.filter((item) => {
                return item.item_id === sku;
            });
            info.value = info.items
                .map((item) => item.price * item.quantity)
                .reduce((prev, next) => {
                return prev + next;
            });
            info.value = Math.round(info.value * 100) / 100;
            sendEvent('remove_from_cart', info);
        })
            .catch((err) => {
            console.error('Error while generating remove_from_cart event', err);
        });
    });
    window.addEventListener('product-show', (e) => {
        const { product } = e.detail;
        sendEvent('view_item', product);
    });
    window.addEventListener('product-list-show', (e) => {
        const { itemList, listName } = e.detail;
        sendEvent('view_item_list', { item_list_name: listName, items: itemList });
    });
    window.addEventListener('wishlist-add', (e) => {
        const detail = e.detail;
        if (typeof detail.sku === 'undefined') {
            return;
        }
        fetch('/api/catalog/product', {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({ sku: detail.sku }),
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error('Unknown failure');
            }
            return response;
        })
            .then((response) => response.json())
            .then((productData) => {
            let rootCategoryName = '';
            if (productData.main_category !== null) {
                for (const category of productData.main_category.path) {
                    if (category.url !== null) {
                        rootCategoryName = category.name;
                        break;
                    }
                }
            }
            const item = {
                item_id: detail.sku,
                item_name: productData.name,
                currency: '',
                discount: productData.catalog_price - productData.price,
                item_brand: 'YvesRocher',
                item_category: rootCategoryName,
                price: productData.price,
            };
            if (typeof window.__STATE__ !== 'undefined') {
                item.currency = window.__STATE__.localization.currency_iso;
            }
            sendEvent('wishlist.product_add', item);
        })
            .catch((err) => {
            console.error('Error while generating wishlist.product_add event', err);
        });
    });
    window.dispatchEvent(new CustomEvent('ga4-loaded', { bubbles: true }));
};
export default () => {
    init();
};
